import React from 'react';
import {
  Section,
  ActionButton,
  Body,
  Carousel,
  ImageCar,
  LoadingShimmer
} from '@icarros/ids-react';
import {
  BodyWrapper,
  CarouselWrapper,
  ImagesCarWrapper,
  ResumeDetailsWrapper,
  ResumeTitleWrapper
} from './style';
import { useAdContext } from '../../../store/contexts/ad';

import { useAd } from '../../../store/hooks/useAd';
import { EDIT_ROUTES } from '../../../utils/adEditRoutes';
import { getDefaultImages } from '../../../utils/getDefaultImages';
import { pushSellerPFDashboardEvent } from '../../../../utils/pushToDataLayer';

export function Photos(): JSX.Element {
  const { currentAd } = useAdContext();
  const { pushToEditForm } = useAd();

  const { fotos } = currentAd || {};

  const defaultImages = getDefaultImages(fotos);

  return (
    <ResumeDetailsWrapper>
      <ResumeTitleWrapper>
        <Section size="section_1">fotos do anúncio</Section>
        <ActionButton
          iconName="itaufonts_educacao_uso_consc"
          text="editar"
          variant="secondary"
          weight="small"
          onClick={() => {
            pushSellerPFDashboardEvent('fotos do anúncio', 'editar');
            pushToEditForm(EDIT_ROUTES.photos.name);
          }}
        />
      </ResumeTitleWrapper>
      {!defaultImages ? (
        <BodyWrapper>
          <Body size="body_2">Você não adicionou fotos no anúncio.</Body>
        </BodyWrapper>
      ) : (
        <LoadingShimmer show={!currentAd} height="80px" width="320px">
          {defaultImages.length > 3 ? (
            <CarouselWrapper>
              <Carousel
                carouselType="horizontal"
                images={defaultImages.map(({ index, src }) => (
                  <ImageCar imageUrl={src} key={index} />
                ))}
              />
            </CarouselWrapper>
          ) : (
            <ImagesCarWrapper>
              {defaultImages.map(({ index, src }) => (
                <ImageCar imageUrl={src} key={index} imageAlt={`foto do veiculo ${index + 1}`} />
              ))}
            </ImagesCarWrapper>
          )}
        </LoadingShimmer>
      )}
    </ResumeDetailsWrapper>
  );
}
